
export const API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5234/api' : '/HeAuth/api';
export const TOKEN_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5234/Token' : '/HeAuth/Token';
export const MIN_PASSWORD_LENGTH = 14;